import { GetReceiptResponse } from 'src/sdk-servicing';
import { createAction, props } from '@ngrx/store';
import { asyncProps, FromApiActionPayload, WithRequestId, AsyncRequest } from '@lib/store';
import { GetReceiptModel } from './get-receipt.state';

/** StateDetailsActions */
const ACTION_SET = '[GetReceipt] set';
const ACTION_UPDATE = '[GetReceipt] update';
const ACTION_RESET = '[GetReceipt] reset';
const ACTION_FAIL = '[GetReceipt] fail';
const ACTION_CANCEL_REQUEST = '[GetReceipt] cancel request';

/** Async Actions */
const ACTION_SET_FROM_API = '[GetReceipt] set from api';
const ACTION_UPDATE_FROM_API = '[GetReceipt] update from api';

/**
 * Clear the current store object and replace it with the new one,
 * update isFailure to false, and update isPending with the boolean given as parameter if defined
 */
export const setGetReceipt = createAction(ACTION_SET, props<WithRequestId<GetReceiptModel>>());

/**
 * Change a part or the whole object in the store and update isFailure to false. The pendingUpdate boolean,
 * if set to true or false, will update the isPending property from the StateDetails
 */
export const updateGetReceipt = createAction(ACTION_UPDATE, props<WithRequestId<Partial<GetReceiptModel>>>());

/**
 * Clear the whole state, return to the initial one
 */
export const resetGetReceipt = createAction(ACTION_RESET);

/** Action to cancel a Request ID registered in the store. Can happen from effect based on a switchMap for instance */
export const cancelGetReceiptRequest = createAction(ACTION_CANCEL_REQUEST, props<AsyncRequest>());

/**
 * Update isPending from the StateDetails to false, and isFailure to true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const failGetReceipt = createAction(ACTION_FAIL, props<WithRequestId<{ error: any }>>());

/**
 * Update isPending to true, triggers setFromApi Effect
 */
export const setGetReceiptFromApi = createAction(
  ACTION_SET_FROM_API,
  asyncProps<FromApiActionPayload<GetReceiptResponse>>()
);

/**
 * Update isPending to true, triggers updateFromApi Effect
 */
export const updateGetReceiptFromApi = createAction(
  ACTION_UPDATE_FROM_API,
  asyncProps<FromApiActionPayload<GetReceiptResponse>>()
);
